import React, { createContext, useState, useEffect, useContext } from 'react';

const AuthContext = createContext();

export function useAuth() {
    return useContext(AuthContext);
}

export const AuthProvider = ({ children }) => {
    const [currentUser, setCurrentUser] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const checkAuth = async () => {
            const token = localStorage.getItem('pro_token') || sessionStorage.getItem('pro_token') || localStorage.getItem('admin_token') || sessionStorage.getItem('admin_token');
            if (token) {
                try {
                    const API_BASE = process.env.REACT_APP_API_URL || '';
                    const res = await fetch(`${API_BASE}/api/auth/me`, {
                        headers: { Authorization: `Bearer ${token}` }
                    });
                    if (res.ok) {
                        const user = await res.json();
                        setCurrentUser(user);
                    } else {
                        localStorage.removeItem('pro_token');
                        sessionStorage.removeItem('pro_token');
                        localStorage.removeItem('admin_token');
                        sessionStorage.removeItem('admin_token');
                    }
                } catch (err) {
                    localStorage.removeItem('pro_token');
                    sessionStorage.removeItem('pro_token');
                    localStorage.removeItem('admin_token');
                    sessionStorage.removeItem('admin_token');
                }
            }
            setLoading(false);
        };
        checkAuth();
    }, []);

    const login = (token, user, rememberMe = true) => {
        const tokenKey = user.role === 'admin' ? 'admin_token' : 'pro_token';
        if (rememberMe) {
            localStorage.setItem(tokenKey, token);
        } else {
            sessionStorage.setItem(tokenKey, token);
        }
        setCurrentUser(user);
    };

    const logout = () => {
        localStorage.removeItem('pro_token');
        sessionStorage.removeItem('pro_token');
        localStorage.removeItem('admin_token');
        sessionStorage.removeItem('admin_token');
        setCurrentUser(null);
    };

    const value = {
        currentUser,
        login,
        logout,
        loading
    };

    return (
        <AuthContext.Provider value={value}>
            {!loading && children}
        </AuthContext.Provider>
    );
};
